module.exports = __webpack_public_path__ + "static/media/insights-banner-mobile.8d9ee193.svg";